import { getRequest, patchRequest } from 'apis/ApiInstence';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const UpdateCommercialService = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  const [formData, setFormData] = useState({
    name: '',
    image: null,
  });
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const fetchService = async () => {
      try {
        const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
        const res = await getRequest(`commercial-service/one/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data) {
          setFormData({
            name: res.data.name,
            image: null,
          });
          if (res.data.image) {
            setPreviewImage(`${process.env.REACT_APP_BACKEND}commercial_services/${res.data.image}`);
          }
        }
      } catch (error) {
        console.error('Error fetching service:', error);
        toast.error('Failed to load service details');
      } finally {
        setFetching(false);
      }
    };
    fetchService();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
      setPreviewImage(URL.createObjectURL(files[0]));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    if (formData.image) {
      formDataToSend.append('image', formData.image);
    }

    try {
      const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
      if (!token) {
        toast.error('Authentication token missing. Please login again.');
        navigate('/signin');
        return;
      }
      await patchRequest(`commercial-service/${id}`, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        }
      });
      toast.success('Service updated successfully!');
      navigate('/commercial-services');
    } catch (error) {
      console.error('Error updating service:', error);
      toast.error(error.response?.data?.message || 'Failed to update service');
    } finally {
      setLoading(false);
    }
  };

  if (fetching) return <div className="text-center mt-5">Fetching service details...</div>;

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="font-weight-bold">Update Commercial Service</h4>
      </div>

      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-5">
          <div className="col-sm-6 mt-2">
            <label htmlFor="name" className="lables">Service Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="image" className="lables">Service Image (optional)</label>
            <input
              type="file"
              id="image"
              name="image"
              className="form-control"
              accept="image/*"
              onChange={handleChange}
            />
            {previewImage && (
              <div className="mt-2">
                <img src={previewImage} alt="Preview" width={150} style={{ borderRadius: '8px' }} />
              </div>
            )}
          </div>
        </div>

        <div className="mt-5 text-right mx-4">
          <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
            {loading ? 'Updating...' : 'Update Service'}
          </button>
        </div>
      </form>
    </div >
  );
};

export default UpdateCommercialService;
